
// Bundle analyzer utility for performance monitoring
export const bundleAnalyzer = {
  // Analyze bundle size and report large chunks
  analyzeBundleSize: () => {
    if (typeof window !== 'undefined' && import.meta.env.DEV) {
      console.group('Bundle Size Analysis');
      
      // Analyze performance entries
      const entries = performance.getEntriesByType('navigation');
      if (entries.length > 0) {
        const navigationEntry = entries[0] as PerformanceNavigationTiming;
        console.log('DOM Content Loaded:', navigationEntry.domContentLoadedEventEnd - navigationEntry.domContentLoadedEventStart, 'ms');
        console.log('Load Complete:', navigationEntry.loadEventEnd - navigationEntry.loadEventStart, 'ms');
      }
      
      console.groupEnd();
    }
  },

  // Monitor resource loading
  monitorResourceLoading: () => {
    if (typeof window !== 'undefined') {
      const observer = new PerformanceObserver((list) => {
        list.getEntries().forEach((entry) => {
          // Cast to PerformanceResourceTiming to access transferSize
          const resourceEntry = entry as PerformanceResourceTiming;
          if (resourceEntry.transferSize && resourceEntry.transferSize > 100000) { // > 100KB
            console.warn(`Large resource detected: ${resourceEntry.name} (${Math.round(resourceEntry.transferSize / 1024)}KB)`);
          }
        });
      });
      
      observer.observe({ entryTypes: ['resource'] });
      return observer;
    }
  }
};
